import { getPreferredBookmaker } from "../components/lib/oddsGames";

const ALL_OPTION = { title: "All", key: "All" };

/**
 * Build league/sport tabs from loaded games (Live bets, A-Z Betting).
 * Mirrors pre-game RadioSelector options ({ title, key }).
 */
export const buildLiveSportNavOptions = (liveGames = []) => {
  const seen = new Map();

  liveGames.forEach((game) => {
    if (!getPreferredBookmaker(game?.bookmakers)) return;
    const key = game.sport_key || game.sport_title;
    const title = game.sport_title || key;
    if (!key || seen.has(key)) return;
    seen.set(key, { title, key });
  });

  const sportOptions = Array.from(seen.values()).sort((a, b) =>
    a.title.localeCompare(b.title)
  );

  return sportOptions.length > 1 ? [ALL_OPTION, ...sportOptions] : [ALL_OPTION];
};

/** Client-side filter when a live sport tab is selected. */
export const filterLiveGamesBySportTab = (liveGames = [], selectedOption) => {
  const selectedKey = selectedOption?.key || selectedOption?.title;
  if (!selectedKey || selectedKey === "All") {
    return liveGames;
  }

  return liveGames.filter(
    (game) =>
      game.sport_key === selectedKey || game.sport_title === selectedKey
  );
};

export const isLiveSportTabValid = (navOptions = [], selectedOption) => {
  const selectedKey = selectedOption?.key || selectedOption?.title || "All";
  if (selectedKey === "All") return true;
  return navOptions.some((option) => option.key === selectedKey);
};
